export default __webpack_public_path__ + "static/media/CONSTRUCTION_SUPPLIERS.e8dff20c.png";